import { render, staticRenderFns } from "./TableGeneric.vue?vue&type=template&id=7bb711aa&scoped=true"
import script from "./TableGeneric.vue?vue&type=script&lang=ts"
export * from "./TableGeneric.vue?vue&type=script&lang=ts"
import style0 from "./TableGeneric.vue?vue&type=style&index=0&id=7bb711aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb711aa",
  null
  
)

export default component.exports